import { Icon, Tooltip } from '@dev-spendesk/grapes';
import classNames from 'classnames';
import React from 'react';

import { PanelItemsSection } from 'common/components/Panel';
import {
  computeLineItemTotalAmountWithTax,
  isOutstandingLineItem,
} from 'modules/purchase-orders/models/threeWayMatch';
import { useTranslation } from 'src/core/common/hooks/useTranslation';
import { type CurrenciesKey } from 'src/core/config/money';
import { formatMonetaryValue } from 'src/core/utils/monetaryValue';

import type { LineItem } from '../ManageLineItemsModal/types';

type Props = {
  before?: React.ReactNode;
  lineItems: LineItem[];
  currency: CurrenciesKey;
};
export const InvoiceLineItemsPanelSection = ({
  before,
  lineItems,
  currency,
}: Props) => {
  const { t } = useTranslation('global');

  return (
    <>
      {before}
      <PanelItemsSection
        title={t('requests.panel.invoice.lineItems.overview.title')}
        items={lineItems.map((lineItem) => {
          const isOutstandingItem = isOutstandingLineItem(lineItem);

          return {
            key: lineItem.id ?? lineItem.description,
            label: (
              <>
                <span
                  className={classNames(
                    'flex flex-1 items-center text-content-secondary-bg-primary',
                    {
                      'text-content-warning-default': isOutstandingItem,
                    },
                  )}
                >
                  {isOutstandingItem && (
                    <Tooltip
                      content={t(
                        'requests.panel.invoice.lineItems.overview.outstandingItemInfo',
                      )}
                      triggerAsChild
                    >
                      <Icon name="triangle-warning" size="m" className="mr-4" />
                    </Tooltip>
                  )}
                  {lineItem.unitQuantity}x {lineItem.description}
                </span>
              </>
            ),
            value: (
              <span
                className={classNames({
                  'text-content-warning-default': isOutstandingItem,
                })}
              >
                {formatMonetaryValue(
                  computeLineItemTotalAmountWithTax(lineItem, currency),
                )}
              </span>
            ),
          };
        })}
      />
    </>
  );
};
